/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SidebarItem } from "./SidebarItem";
import { SidebarItemListProps, UISidebarProps } from "./types";

type SidebarItemProps = {
  excludeItems?: string[];
};

type Props = SidebarItemListProps & SidebarItemProps & UISidebarProps;

export function SidebarItemList({
  items,
  hasSubtitle,
  hasIcon,
  onSubmit,
  excludeItems,
}: Props) {
  return (
    <>
      {items.map((item) => (
        <SidebarItem
          key={item.value}
          hasSubtitle={hasSubtitle}
          hasIcon={hasIcon}
          item={item}
          disabled={excludeItems?.includes(item.value) ?? false}
          onSubmit={() => onSubmit(item?.value)}
        />
      ))}
    </>
  );
}
